module.exports = __webpack_public_path__ + "static/media/list-view-icon-active.eb094254.png";